import { createSlice } from '@reduxjs/toolkit'

// workaround for browser-only feature gatsby
let productLocalStorage;
let locationLocalStorage;
if (typeof window !== 'undefined') {
  productLocalStorage = JSON.parse(localStorage.getItem('product') || '{}');
  locationLocalStorage = JSON.parse(localStorage.getItem('location') || '{}')
}

export interface ProductState {
  loading: boolean,
  product: any,
  location: any,
  extras: string[],
  error: string,
  success: boolean,
  extrasPrice: number,
}

const initialState: ProductState = {
  loading: false,
  product: productLocalStorage || null,
  location: locationLocalStorage || null,
  extras: [],
  extrasPrice: 0,
  error: '',
  success: false, // for monitoring the registration process.
}

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProduct: (state, action) => {
      state.product = action.payload;
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    setExtras: (state, action) => {
      const updateState: string[] = [...state.extras, action.payload];

      state.extras = updateState;
    },
    removeExtras: (state, action) => {
      const filterState: string[] = state.extras.filter((id: string) => id !== action.payload)

      state.extras = filterState;
    },
    setExtrasPrice: (state, action) => {
      state.extrasPrice = action.payload;
    }
  },
  extraReducers: (builder) => {},
})

export const { setProduct, setLocation, setExtras, removeExtras, setExtrasPrice } = productSlice.actions
export default productSlice.reducer